module.exports = __webpack_public_path__ + "img/section2Logo1.8368d081.png";